<template>
    <div>
        <modal :id="modalId" :title="title">
            <upload-box
                ref="uploadBox"
                :url="uploadUrl"
                :param-name="uploadParamName"
                :add-remove-links="false"
                :preview-template="template"
                :thumbnail-width="200"
                :thumbnail-height="200"
                form-method="PATCH"
                @sending="onSending"
                @success="onSuccess"
                @error="onError"
            />

            <template #footer>
                <button type="button" class="btn btn-default" @click="hideModal"><i class="fa fa-fw fa-ban"></i> Close</button>
                <button type="button" class="btn btn-primary" @click.prevent="processUpload"><i class="fa fa-fw fa-upload"></i> Upload</button>
            </template>
        </modal>

        <slot name="hidden"></slot>
    </div>
</template>

<script>/**
   *
   * Component used to upload Adjuster attachment.
   *
   * Emit:
   *  uploaded - event on successful attachment upload; carry new attachment data as payload.
   *
   * Example:
   *
   * <adjuster-upload-modal
   *   :upload-url="uploadUrl"
   *   @uploaded="addLine">
   * </adjuster-upload-modal>
   *
   */
  import HasModal from "../mixins/HasModal";

export default {
    mixins: [HasModal],

    emits: ['uploaded'],

    props: {

      // id of modal form.
      modalId: {
        type: String,
        default: 'adjuster-upload-modal',
      },

      // title of modal form.
      title: {
        type: String,
        default: 'Upload Adjuster attachments',
      },

      // Url for attachment upload request.
      uploadUrl: {
        required: true,
        type: String,
      },

      // Parameter name for uploading attachment.
      uploadParamName: {
        type: String,
        default: 'upload'
      }
    },

    data() {

      return {
        template: '',
      };

    },

    mounted() {
      let preview = document.getElementById('dz-adjuster-file-template');
      preview.removeAttribute('id');
      preview.classList.remove('d-none');
      preview.remove();
      this.template = preview.outerHTML;
    },

    methods: {
      /**
       * Attach additional fields to file upload request.
       */
      onSending(file, xhr, formData) {
        let fileType = $(file.previewElement).find('.file-type').val();
        formData.append('file_type', fileType);
      },

      /**
       * Handler for sending files error.
       */
      onError(file, message, xhr) {
        if (!xhr || xhr.status === 422) {
          this.showErrorModal(message + ' Please replace/remove failed files.');
        } else {
          this.showErrorModal('Failed to send attachments. Please replace/remove failed files.');
        }
      },

      /**
       * Handler for sending files success.
       */
      onSuccess(file, response) {
        // Delete successfully uploaded file from dropzone list.
        this.$refs.uploadBox.removeFile(file);
        // Add newly uploaded file to list.
        this.$emit('uploaded', response.data);
      },

      /**
       * Process uploading queue in dropzone.
       */
      processUpload() {
        this.$refs.uploadBox.process();
      },
    }
  }

</script>
